import React from 'react';
import { Flex, Switch, Text } from 'UI';

interface NotificationSwitchProps {
  label: string;
  isEnabled: boolean;
  onChange: (enabled: boolean) => void;
  'data-cy'?: string;
  title?: string;
  disabled?: boolean;
}

export const NotificationSwitch = ({
  label,
  isEnabled,
  onChange,
  'data-cy': dataCy,
  title,
  disabled,
}: NotificationSwitchProps) => {
  return (
    <Flex direction={'row'} justify={'space-between'} align={'center'} minWidth={100} gap={15}>
      <Flex direction={'column'}>
        {!!title && <Text type="heading4">{title}</Text>}
        <Text type="base">{label}</Text>
      </Flex>
      <Switch onChange={onChange} checked={isEnabled} data-cy={dataCy} disabled={disabled} />
    </Flex>
  );
};
